// The read and the write of a thread's actions list both carry the whole list back, so one handler files
// both. Scoped by the thread that owns the response, the same shape as threadAppConnectionStatus.
// `latestRunStartedOn` rides with the list because together they answer which answers Pieve has not
// been handed yet (contract C5).
const applyThreadActionsPayload = (state, payload) => {
  return {
    ...state,
    workflowActions: Array.isArray(payload?.data) ? payload.data : [],
    workflowActionsThreadId: String(payload?.meta?.threadId || '').trim() || null,
    workflowActionsLatestRunStartedOn: String(payload?.meta?.latestRunStartedOn || '').trim() || null
  };
};

export default applyThreadActionsPayload;
